import { Component, input, output } from '@angular/core';

/**
 * Controlled checkbox: the box always shows the bound `checked` value. A tap only
 * reports the intended value through `checkedChange`; the parent decides whether it
 * sticks (e.g. after the mount request or a checklist dialog), so the box can never
 * drift from the stored state.
 */
@Component({
  selector: 'mbm-checkbox',
  imports: [],
  templateUrl: './mbm-checkbox.component.html',
  styleUrl: './mbm-checkbox.component.scss',
})
export class MbmCheckboxComponent {
  readonly checked = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly checkedChange = output<boolean>();

  protected onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const next = target.checked;
    target.checked = this.checked();
    this.checkedChange.emit(next);
  }
}
